import React, { createContext, ReactNode, useState, useEffect } from 'react';
import UserStore from '../user/user.store';
import PTestStore from '../onboarding/p-test.store';
import OnboardingStore from '../onboarding/onboarding.store';
import { userUpdate, signOut } from '../user/user-update.service';

export class RootStore {
  static instance: RootStore | null = null;

  userStore: UserStore;
  onboardingStore: OnboardingStore;
  PTestStore: PTestStore;

  constructor() {
    this.userStore = new UserStore(userUpdate);
    this.PTestStore = new PTestStore();
    this.onboardingStore = new OnboardingStore(this.userStore, this.PTestStore);
  }

  static init(): RootStore {
    if (!RootStore.instance) {
      RootStore.instance = new RootStore();
    }
    return RootStore.instance;
  }

  cleanup = () => {
    this.userStore.clearUser();
    this.onboardingStore.resetForm();
  };

  async signOut() {
    await signOut();
    this.cleanup();
  }
}

export const RootStoreContext = createContext<RootStore>(null as any);

interface RootStoreProviderProps {
  children: ReactNode;
}

export const RootStoreProvider = ({ children }: RootStoreProviderProps) => {
  const [rootStore] = useState(() => RootStore.init());

  useEffect(() => {
    return () => {
      // Cleanup when provider unmounts
      rootStore.cleanup();
    };
  }, [rootStore]);

  return (
    <RootStoreContext.Provider value={rootStore}>
      {children}
    </RootStoreContext.Provider>
  );
};
